import { HiveCanvasLayout } from './canvas/HiveCanvasLayout.js';
import { HiveOverlay } from './HiveOverlay.js';
import { OverlayProvider } from '../../core/components/overlay-tooltip/contexts/OverlayContext.js';
import { TooltipProvider } from '../../core/components/overlay-tooltip/contexts/TooltipContext.js';
import { useHoneycombLoading } from '../hooks/use-honeycomb-loading.js';
import { HiveProviders } from '../providers/hive.providers.js';

export const HoneycombHive = () => {
  const loading = useHoneycombLoading();
  return (
    <HiveProviders>
      <OverlayProvider>
        <TooltipProvider>
          <HiveCanvasLayout />
          {loading ? null : <HiveOverlay />}
        </TooltipProvider>
      </OverlayProvider>
    </HiveProviders>
  );
};

HoneycombHive['displayName'] = 'HoneycombHive';
